import axios from 'axios';

let client = axios.create({
    baseURL: process.env.VUE_APP_DX_URL || null
});

export default client;
